import type { EditDetailedSummaryFormProps } from '../components/EditDetailedSummaryModal/form/types'
import type { EditDetailedSummaryRequestProps } from '@services/api/invoicing/types'

export const parseEditDetailedSummaryPayload = (formData: EditDetailedSummaryFormProps) => {
  const payload: EditDetailedSummaryRequestProps = {
    id: formData.id || null,
    filiCode: formData.filiCode,
    fatDtCompetencia: formData.competenceDate,
    minimumBilling: Number(formData.minimumBilling),
    provisions: Number(formData.provisions),
    reversals: Number(formData.reversals),
    adjustments: Number(formData.adjustments)
  }

  return payload
}
